import { createSlice } from "@reduxjs/toolkit";
import { RequestState } from "common/RequestState";

export const createGenericSlice = name => {
  return createSlice({
    name: name,
    initialState: {
      _requestState: RequestState.NotRequested
    },
    reducers: {
      requested: state => {
        state._requestState = RequestState.InProgress;
      },
      received: (state, action) => {
        state.payload = action.payload;
        state._requestState = RequestState.Finished;
      },
      failed: state => {
        state._requestState = RequestState.Failed;
      }
    }
  });
};
